import React, {useRef, useEffect} from "react"
import { useStore } from "../../teafuljs/store"
import { get, set, del, keys } from "idb-keyval"
import PropTypes from "prop-types"
import "../../../static/global.css"

import Header from "./header"
import NavButtons from "./navButtons"
import SVLogo from "../../../static/images/SVLogo.jpeg"
import { ThemeProvider } from "@material-ui/styles"
import theme from "../../theme"
import Container from "@material-ui/core/Container"
import SortBooks from "../../scripts/sortBooksByBibleOrder"
import { getMetadata } from "../../scripts/getMetadata"
import FooterNav from "./footerNav"

import BibleBookList from "../../data/BookChapterList.json"
import SegmentTitles from "../../data/SegmentTitles.json"
import { getDocument } from "../../apis/firebase"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import { validateVersion } from "../../scripts/validateVersion"
import PWAInstallOverlay from "../PWAInstallOverlay"

const isBrowser = typeof window !== "undefined"

const WrapLayout = ({ children, location }) => {
  const [AvailableContent, setAvailableContent, resetAvailableContent] = useStore.AvailableContent();
  const [stateLanguage, setLanguage, resetLanguage] = useStore.language();
  const [stateVersion, setVersion, resetVersion] = useStore.version();
  const [stateMetadata, setMetadata, resetMetadata] = useStore.metadata();
  const [stateCurrentBook, setCurrentBook, resetCurrentBook] = useStore.currentBook();
  const [currentSegmentID, setCurrentSegmentID, resetCurrentSegmentID] = useStore.currentSegmentID();
  const [stateRefID, setRefID, resetRefID] = useStore.refID();
  const [stateTranslations, setTranslations, resetTranslations] = useStore.translations();
  const [stateVersification, setVersification, resetVersification] = useStore.versification();
  const [stateInterlinear, setInterlinear, resetInterlinear] = useStore.interlinear();
  const [readPlan, setReadPlan, resetReadPlan] = useStore.readPlan();
  const [readPlanID, setReadPlanID, resetReadPlanID] = useStore.readPlanID();
  const metadataCalled = useRef(false);

  const storeMetadata = async (
    language,
    version
  ) => {
    metadataCalled.current = true;
    const metadata = await getMetadata(
      language,
      version
    )
    console.log(
      "store metadata",
      metadata
    )
    setMetadata(metadata)
  }

  const processHashRefs = (hashRefs) => {
    const language = hashRefs
      ? hashRefs[0].substring(1)
      : isBrowser
      ? localStorage.getItem("currentLanguage")
      : "ENG"
    const version = hashRefs
      ? hashRefs[1]
      : isBrowser
      ? localStorage.getItem("currentVersion")
      : "NLT"
    if (AvailableContent && AvailableContent.content) {
      const validated = validateVersion(AvailableContent, language, version)
      if (validated) {
        console.log('validated version: ', `${language}-${version}`)
        setLanguage(language);
        setVersion(version);
      } else {
        console.log('reset to ENG-NLT')
        setLanguage('ENG')
        setVersion("NLT")
        return {
          language: "ENG",
          version: "NLT",
        }
      }
    } else {
        console.log("no AvailableContent yet...", `${language}-${version}`)
        setLanguage(language)
        setVersion(version)
    }
    return { language, version }
  }

  useEffect(() => {
    console.log("WrapLayout useEffect")
    if (location.hash !== "" && !AvailableContent) {
      let updateStateCalls = []
      const hashRefs = location.hash.split("-")
      console.log("hashRefs", hashRefs)

      const {language, version} = processHashRefs(hashRefs);
      // const language = hashRefs
      //   ? hashRefs[0].substring(1)
      //   : isBrowser ? localStorage.getItem("currentLanguage") : "ENG"
      // if (language !== stateLanguage && hashRefs) {
      //   updateStateCalls.push(() => {
      //     setLanguage(language)
      //   })
      // }
      // console.log(
      //   "hashRefs[1]",
      //   hashRefs[1],
      //   localStorage.getItem("currentVersion"),
      //   stateVersion,
      //   location
      // )
      // const version = !!hashRefs
      //   ? hashRefs[1]
      //   : isBrowser ? localStorage.getItem("currentVersion") : 'NLT'
      // console.log('Chosen Version', version, !!hashRefs)
      // if (version !== stateVersion && hashRefs) {
      //   updateStateCalls.push(() => {
      //     setVersion(version)
      //   })
      // }
      if (
        validateVersion(AvailableContent, language, version) &&
        language &&
        version &&
        !stateMetadata &&
        !metadataCalled.current
      ) {
        storeMetadata(language, version)
      }
      // Process Book first so that we can update it when updating the segment data if necessary
      const book =
        hashRefs && Object.keys(BibleBookList).indexOf(hashRefs[3]) !== -1
          ? hashRefs[3]
          : null
      if (book && book !== stateCurrentBook && hashRefs) {
        updateStateCalls.push(() => {
          setCurrentBook(book)
        })
      }
      const URLsegment = hashRefs
        ? hashRefs[2]
        : isBrowser && localStorage.getItem("lastSegment")
        ? localStorage.getItem("lastSegment")
        : null

      console.log(language, version, URLsegment)
      if (URLsegment && URLsegment !== currentSegmentID) {
        if (!book) {
          updateStateCalls.push(() => {
            setCurrentBook(SegmentTitles[URLsegment].book[0])
          })
        }
        updateStateCalls.push(() => {
          setCurrentSegmentID(URLsegment)
        })
      }
      const chapter =
        typeof parseInt(hashRefs[4]) === "number" ? hashRefs[4] : null
      const verse =
        typeof parseInt(hashRefs[5]) === "number" ? hashRefs[5] : null
      if (
        book &&
        chapter &&
        verse &&
        `${book}-${hashRefs[4]}-${hashRefs[5]}` !== stateRefID
      ) {
        updateStateCalls.push(() => {
          setRefID(`${book}-${hashRefs[4]}-${hashRefs[5]}`)
        })
      }
      if (updateStateCalls.length > 0) {
        updateStateCalls.map(call => call())
      }
    }
  }, [location.pathname])

  // -------------------------------------------------- //
  // -------------- STATE OF THE WEB APP -------------- //
  // -------------------------------------------------- //

  // Update AvailableContent if necessary

  if (!AvailableContent) {
    getDocument(
      "refDocs/availableContent"
    ).then(response => {
      if (
        response.data() !== null
      ) {
        del("AvailableContent")
        set(
          "AvailableContent",
          response.data()
        )
          .then(() => {})
          .catch(err =>
            console.log(
              "error with IDB AvailableContent",
              err
            )
        )
        setAvailableContent(response.data())
      } else {
        get(
          "AvailableContent"
        ).then(val => {
          if (!val) {
            console.log(
              "AvailableContent in indexedDB is null"
            )
            // delete fetch url from cache
          } else {
            console.log(
              "loading Available Content from indexedDB"
            )
            setAvailableContent(val.content)
          }
        })
      }
    })
  }

  // Get translations if necessary
  if (
    AvailableContent &&
    AvailableContent
      .content
  ) {
    if (
      !stateTranslations ||
      !stateTranslations[
        stateLanguage
      ]
    ) {
      const translationLanguage =
        stateLanguage ===
          "CMN" &&
        stateVersion === "CCBT"
          ? "CMNT"
          : stateLanguage
      getDocument(`translations/${translationLanguage}`).then(response => {
        if (response.data() !== null) {
          set(`${stateLanguage}-translations`, response.data())
          setTranslations({ [stateLanguage]: response.data() })
        } else {
          get(`${stateLanguage}-translations`).then(val => {
            if (!val) {
              console.log(`${stateLanguage}-translations in indexedDB is null`)
              // delete fetch url from cache
            } else {
              setTranslations({ [stateLanguage]: response.data })
            }
          })
        }
      })
    }

    if (
      !stateMetadata && !metadataCalled.current &&
      stateLanguage &&
      stateVersion
    ) {
      storeMetadata(
        stateLanguage,
        stateVersion
      )
    }
  }
  // Get versification
  if (
    AvailableContent &&
    AvailableContent
      .content
  ) {
    if (!stateVersification || !stateVersification[stateVersion]) {
      getDocument(
        `versification/${stateLanguage}-${stateVersion}`
      ).then(response => {
        if (response.data() !== null) {
          set(`${stateVersion}-versification`, response.data())
          setVersification({
            [stateVersion]: response.data(),
          })
        } else {
          get(`${stateLanguage}-versification`).then(val => {
            if (!val) {
              console.log(`${stateLanguage}-versification in indexedDB is null`)
              // delete fetch url from cache
            } else {
              setVersification({
                [stateVersion]: response.val(),
              })
            }
          })
        }
      })
    }
  }

  async function updateSegmentList() {
    console.log(
      `WrapLayout 251 [updateSegmentList]`,
      stateLanguage,
      stateVersion
    )
    if (!validateVersion(AvailableContent, stateLanguage, stateVersion)) return
    console.log("updateSegmentList from indexedDB")
    await keys().then(keys => {
      let books = SortBooks(
        Object.keys(
          AvailableContent
            .content[
            stateLanguage
          ][stateVersion]
        )
      )
      let segments = []
      books.forEach(book => {
        segments = [
          ...segments,
          ...AvailableContent
            .content[
            stateLanguage
          ][stateVersion][book]
            .segments,
        ]
      })
      const readingPlanStatusObj = {}
      segments.map(
        async segment => {
          if (
            keys.indexOf(
              `readingPlan-${
                stateLanguage
              }-${
                stateVersion
              }-${segment}`
            ) !== -1
          ) {
            readingPlanStatusObj[
              `readingPlan-${
                stateLanguage
              }-${
                stateVersion
              }-${segment}`
            ] = true
          }
        }
      )
      console.log("readingPlanStatusObj", readingPlanStatusObj)
      setReadPlan(readingPlanStatusObj)
      setReadPlanID(readPlanID + 1)
    })
  }

  if (
    !readPlan &&
    AvailableContent
  ) {
    updateSegmentList()
  }

  // -------------------------------------------------- //
  // ------------------- END OF STATE ----------------- //
  // -------------------------------------------------- //
  if (AvailableContent && AvailableContent.content) {
    return (
      <ThemeProvider theme={theme}>
        <Header
          interlinear={stateInterlinear}
          version={stateVersion}
          showIcons={location.pathname !== "/" ? true : false}
          currentLocation={location}
          segmentID={currentSegmentID}
        />
        {location.pathname === "/biblica-info" ? (
          <main>{children}</main>
        ) : (
          <Container>
            <main>{children}</main>
          </Container>
        )}
        {location.pathname === "/reader" || location.pathname === "/reader/" ? (
          <NavButtons location={location} />
        ) : (
          <FooterNav />
        )}
        <PWAInstallOverlay />
      </ThemeProvider>
    )
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "center",
        }}
      >
        <div style={{ margin: "auto" }}>
          <img
            src={SVLogo}
            style={{
              position: "relative",
              width: "200px",
              height: "200px",
              flex: "1",
              margin: "0 auto",
            }}
            alt="SourceView Bible Logo"
          />
          <LoadingSpinner />
        </div>
      </div>
    )
  }
}

WrapLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default WrapLayout
